<template>
	<div class="profile-image-upload">
		<div class="mb-2">
			<div class="inline-block relative">
				<svg id="svg" width="200" height="200" viewPort="0 0 100 100" version="1.1" xmlns="http://www.w3.org/2000/svg">
					<circle r="88" cx="100" cy="100" fill="transparent" stroke-dasharray="565.48" stroke-dashoffset="0"></circle>
					<circle class="bar" ref="bar" r="88" cx="100" cy="100" fill="transparent" stroke-dasharray="565.48" stroke-dashoffset="0" transform="rotate(90 100 100) scale(-1, 1) translate(-200, 0)"></circle>
				</svg>
				<img class="profile-image" :src="image" alt="">
			</div>
		</div>
		<input type="hidden" name="remove_old_image" :value="removeOldImage ? '1' : '0'">
		<input type="file" style="display: none;" name="profile_image" @change="imageFieldChange" ref="imageUpload" accept="image/jpeg,image/png,image/jpg,.jpeg,.jpg,.png">
		<button class="no-style-button" type="button" @click="pickImage()">Välj ny bild</button> | <button class="no-style-button" type="button" @click="removeImage()" v-show="!removeOldImage">Radera bild</button>
		<button class="no-style-button" type="button" @click="restoreImage()" v-show="removeOldImage">Återställ bild</button>

		<div><small>Bilden du väljer måste vara mindre än 3MB stor.</small></div>

		<div v-if="showFileSizeError">Bilden du har valt är större än 3MB. Välj en annan bild eller förminska bilden och försök igen.</div>
	</div>
</template>
<script>
export default {
	props: ['profileImage', 'originalImage', 'defaultImage', 'percentage'],
	data() {
		return {
			image: this.profileImage,
			removeOldImage: false,
			showFileSizeError: false
		}
	},
	methods: {
		restoreImage() {
			this.image = this.originalImage;
			this.removeOldImage = false;
		},
		removeImage() {
			this.$refs.imageUpload.value = "";
			this.image = this.defaultImage;
			this.removeOldImage = true;
		},
		pickImage() {
			jQuery(this.$refs.imageUpload).trigger("click");
		},
		imageFieldChange() {
			this.showFileSizeError = false;
			var reader  = new FileReader();

			var file = this.$refs.imageUpload.files[0];

			reader.onloadend = () => {
				this.image = reader.result;
			}

			if (file) {
				if(file.size > 3 * 1024 * 1024) {
					this.showFileSizeError = true;
					return false;
				}
				reader.readAsDataURL(file); //reads the data as a URL
				this.removeOldImage = true;
			} else {
				this.image = "";
			}
		},
		updatePercentage() {
			var val = parseInt(this.percentage);

			var r = this.$refs.bar.getAttribute("r");
			var c = Math.PI*(r*2);

			if (val < 0) { val = 0;}
			if (val > 100) { val = 100;}

			var pct = ((100-val)/100)*c;
			this.$refs.bar.style.strokeDashoffset = pct;
		}
	},
	mounted() {
		this.$nextTick(() => {this.updatePercentage();});
	}
}
</script>